import { Entity } from '../../entity';
import { PricelistStatus } from '../../price.book';

/**
 * Where a Visit Job's contact, price book or owner comes from (WBS-12699), in the order Job creation looks:
 * the line's own Job defaults, the plan's Job defaults, then the site's and the customer's records. A Job
 * template's price list outranks the site's and customer's when Job creation names a template.
 */
export enum JobDefaultSource {
    Line = 'Line',
    Plan = 'Plan',
    Site = 'Site',
    Customer = 'Customer',
    JobTemplate = 'JobTemplate',
}

/** One Job default after the fallback chain, with the level that supplied it. */
export interface ResolvedJobDefault {
    value: Entity;
    source: JobDefaultSource;
}

/** The resolved price book also says whether its dates let a Job use it today. */
export interface ResolvedJobPriceBook extends ResolvedJobDefault {
    /** Current, Expired or Future (not active yet); absent until the price book's dates are read. */
    status?: PricelistStatus;
}

/** A Visit Job's contact, price book and owner after the fallback chain; a field nothing supplies is absent. */
export interface ResolvedJobDefaults {
    contact?: ResolvedJobDefault;
    priceBook?: ResolvedJobPriceBook;
    owner?: ResolvedJobDefault;
}
